import { render, staticRenderFns } from "./Fidelization.vue?vue&type=template&id=08b0b1cc"
import script from "./Fidelization.vue?vue&type=script&lang=js"
export * from "./Fidelization.vue?vue&type=script&lang=js"
import style0 from "./Fidelization.vue?vue&type=style&index=0&id=08b0b1cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports